export default __webpack_public_path__ + "static/media/brazil-flag.af633a62.svg";